import { useStartGame } from '../hooks/useStartGame';
import { useLanguage } from '../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import FixedPageWrapper from '../components/wrapper/FixedPageWrapper';
import GhostWrapper from '../components/wrapper/GhostWrapper';
import HomeGhosts from './../components/ghosts/HomeGhosts';
import Header from './../components/general/Header';
import Title from './../components/text/Title';
import Subtitle from './../components/text/Subtitle';
import Button from './../components/general/Button';
import TextLink from './../components/text/TextLink';
import Footer from './../components/general/Footer';

function Home() {
  const { handleStartGame, gameState } = useStartGame();
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <FixedPageWrapper>
      <GhostWrapper>
        <Header text={t('headerTitle')} />
        <Title size="big" text={t('title')} />
        <br />
        <Subtitle position="center" text={t('homepageSubtitle')} />
        <br />
        <TextLink onClick={() => navigate('/game/guide')} text={t('howToPlay')} />
        <br />
        {gameState?.isLoading ? (
          <div className="flex items-center justify-center gap-2 px-6 py-3 font-bold bg-yellow text-text-light rounded-2xl border-b-4 border-r-4 border-orange">
            <div className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-solid border-current border-r-transparent motion-reduce:animate-[spin_1.5s_linear_infinite]" />
            <span>{t('loading')}</span>
          </div>
        ) : (
          <Button text={t('play')} onClick={handleStartGame} />
        )}
      </GhostWrapper>
      <HomeGhosts />
      <Footer />
    </FixedPageWrapper>
  );
}

export default Home;
